<template>
  <div>
    <div class="goodsManageSet">
      <div class="banner">
        <img src="../../../assets/images/banner3.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">商务&销售管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">业务订单审核</div>
      </div>

      <div class="main_content">
        <div class="block">
          <h1>订单审核备注</h1>
          <div class="textarea_box">
            <van-field
              type="textarea"
              v-model="formData.checknote"
              placeholder="请输入订单审核备注"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>订单审核状态</h1>
          <div class="radio_box">
            <van-radio-group
              v-model="formData.ischeck"
              style="justify-content: space-evenly"
            >
              <van-radio name="0" style="margin-bottom: 15px">待审核</van-radio>
              <van-radio name="1" style="margin-bottom: 15px"
                >审核通过</van-radio
              >
              <van-radio name="2" style="margin-bottom: 15px"
                >审核不通过</van-radio
              >
            </van-radio-group>
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import { getOrderListDetail, editOrderCheck } from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cOrderCheck",
  data() {
    return {
      isShowType: 1,
      dataItem: "",
      formData: {
        orderno: "",
        ischeck: "",
        checknote: "",
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { orderId, orderOpenid } = JSON.parse(res.jsondata);
        this.getOrderListDetail(orderId, orderOpenid);
      } else {
        this.$router.back();
      }
    },

    // 仓库配货列表
    getOrderListDetail(orderid, openid) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let params = {
        openid,
        orderid,
      };
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        this.formData.orderno = newObj.orderno;
        this.formData.ischeck = newObj.ischeck;
        this.formData.checknote = newObj.checknote;
        Toast.clear();
      });
    },

    // 保存
    query() {
      let { formData } = this;
      if (formData.ischeck == "") {
        this.$toast("请选择退款审核状态");
        return;
      }
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editOrderCheck(this.formData).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .item {
        margin-bottom: 50px;
      }
      .input_box,
      .select_box {
        margin-bottom: 30px;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
      .warehouse {
        width: 560px;
        margin: auto;
        text-align: left;
      }
    }
  }
}
</style>